import React, { FC } from 'react'

import { BookingPaymentBalanceStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'

import { bookingPaymentOptions } from '../../config/colors'

interface PaymentStatusFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const PaymentStatusFilter: FC<PaymentStatusFilterProps> = ({ onChange, ...props }) => {
  const handleOnChange = (value?: string[]) => {
    if (value?.includes(BookingPaymentBalanceStatus.notPaid)) {
      onChange([...value, BookingPaymentBalanceStatus.partlyPaid])
    } else {
      onChange(value)
    }
  }

  return (
    <CheckboxBasedFilter
      title="Payment Status"
      options={bookingPaymentOptions}
      {...props}
      onChange={handleOnChange}
    />
  )
}
